// extracted by mini-css-extract-plugin
export default {"header":"_Header_header__ABrt9"};